"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderBy = exports.CompatibleOrderByConfig = void 0;
const _ = __importStar(require("lodash"));
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./utils");
class CompatibleOrderByConfig {
    config;
    operation = 'orderBy';
    // Private instance properties allow typescript to ensure that an instance of
    // this class is being used.
    constructor(config) {
        this.config = config;
        this.config = config;
    }
    ensureCompatibility = (loanTape) => {
        const { field, type } = this.config;
        if ((0, utils_1.isCalcPropertyKey)(field)) {
            (0, common_1.finleyAssert)(type === 'number', `Invalid type ${type} for field ${field}`);
            return;
        }
        const invalidRecord = _.find(loanTape, (record) => {
            const value = (0, utils_1.getFieldValue)({ loanTape: record, field });
            return !_.isNil(value) && typeof value !== type;
        });
        (0, common_1.finleyAssert)(!invalidRecord, (0, utils_1.getInvalidFieldTypeMessage)({
            invalidRecord,
            field,
            type,
            operationType: this.operation,
        }));
    };
    static create = (config, loanTape) => {
        const obj = new CompatibleOrderByConfig(config);
        obj.ensureCompatibility(loanTape);
        return obj;
    };
}
exports.CompatibleOrderByConfig = CompatibleOrderByConfig;
const comparableField = ({ field }) => (loanTape) => {
    const value = (0, utils_1.getFieldValue)({
        field,
        loanTape,
    });
    return _.toNumber(value);
};
const fieldIsNotNil = ({ field }) => (loanTape) => !_.isNil((0, utils_1.getFieldValue)({ loanTape, field }));
/*
 * Orders all loan tapes by the value of a field or calc property
 * then selects the first N loanTapes. Calc properties are
 * the calculated values that are used in each step of the
 * borrowing base report generation.
 *
 * example config:
 * {
 *    field: 'borrowingBaseAmount',
 *    operation: 'orderBy'
 *    count: 1,
 *    type: 'number',
 * }
 *
 */
const orderBy = ({ config: { field, order = 'desc', count }, }) => (loanTapeRecords) => (0, remeda_1.pipe)(loanTapeRecords, 
// Selecting loanTapes where the field value is undefined or null is not supported.
// it's unclear whether undefined or null should be sorted at the end with 0 and 'a'
// values or not, so we filter them out instead
(0, remeda_1.filter)(fieldIsNotNil({ field })), (0, remeda_1.sortBy)([
    comparableField({ field }),
    order,
]), (0, remeda_1.take)(count));
exports.orderBy = orderBy;
//# sourceMappingURL=orderBy.js.map